

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import Datim from "@/components/shared/Datim.vue";
import {BoListPanel} from "bonomo/dist";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {IChannelSetting} from "@/model/Channel/IChannelSetting";

const channelModule = namespace("channelModule");
const userModule = namespace("userModule");

@Component({
  components: {
    BoListPanel,
    Datim,
  }
})

export default class Channels extends Vue {

  @channelModule.Action('fetchChannelSettings')
  fetchChannelSettings!: () => void;

  @channelModule.Getter('channelSettings')
  channelSettings!: IChannelSetting[];

  get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.id'), align: 'start', sortable: false, value: 'id' },
      { text: this.$t('common.name'), align: 'start', sortable: false, value: 'name' },
      // { text: this.$t(''), align: 'start', sortable: false, value: 'slug' },
      { text: this.$t('channels.fields.currency.title'), align: 'start', sortable: false, value: 'currency' },
      { text: this.$t('channels.fields.payment_provider.title'), align: 'start', sortable: false, value: 'payment_provider' },
      { text: this.$t('channels.fields.requiresDocumentId.title'), align: 'start', sortable: false, value: 'requiresDocumentId' },
      { text: this.$t('channels.fields.comment.title'), align: 'start', sortable: false, value: 'comment' },
      { text: this.$t('common.createdAt'), align: 'start', sortable: false, value: 'created_at' },
      { text: this.$t('common.updatedAt'), align: 'start', sortable: false, value: 'updated_at' },
    ];
  }
  loading: boolean = false;

  loadData(initial: boolean = false) {
    if (initial || !this.channelSettings.length) {
      this.fetchChannelSettings();
    }
  }



}
